module.exports = __webpack_public_path__ + "static/media/1.f659cea0.jpg";